import { renderer } from "../Renderer";

abstract class Expression {

	private _template:string = "";
	private expressionContent:string;

	abstract update( data:any, attribute?:string );

	/**
	 * Simple test if template has the given attribute in its brankets
	 * @param name
	 */
	hasAttribute( name:string ) {
		if( name == undefined ) return true;
		return this.expressionContent.indexOf( name ) >= 0;
	}

	set template( t:string ) {
		this._template = t;
		this.expressionContent = '';
		t.replace( renderer.pass.regex, ( match, inner ) => {
			this.expressionContent += inner;
			return '';
		});
	}

	get template():string {
		return this._template;
	}
}

export function hasExpression( string:string ):boolean {
	renderer.pass.regex.lastIndex = 0; // reset global regex
	return renderer.pass.regex.test( string );
}
export function snakeToCamel( string ) {
	return string.replace( /(\-\w)/g, match => match[1].toUpperCase() );
}

export function camelToSnake( string ) {
	return string.split(/(?=[A-Z])/).join('-').toLowerCase();
}

export default Expression;
